<ng-container *ngTemplateOutlet="mode === 'home' ? homefilter : nohomefilter"></ng-container>

<ng-template #homefilter>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="homemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="homefilterdesk"></ng-container>
    </ng-container>
</ng-template>

<ng-template #homefilterdesk>
    <div class="tmp-inputs-wrapper">
        <div class="tmp-principal-wrapper">
            <app-city [mode]="'home'"></app-city>
            <clever-date [start]="start" [end]="end" (selectValue)="selectValue($event)" [mode]="'home'"
                class="w300px"></clever-date>
            <clever-selectionlist [icon]="'people_alt'"
                [currentItem]="filter?.adults + (filter?.adults === '1' ? ' Person' : ' Personen')"
                (triggerChange)="selectAdultes($event)" [title]="'Raum für'" [toprightradius]="true"
                [bottomrightradius]="true" [list]="reisende" [mode]="'home'">
            </clever-selectionlist>

            <button matTooltip="Mehr Filter" (click)="openclosemore()" matRipple>
                <mat-icon fontIcon="more_vert"></mat-icon>
            </button>
            <button class="tmpsearch tmpbtn tmp-left tmp-right" (click)="gotoZiel()" matRipple>
                <mat-icon fontIcon="search"></mat-icon>
                <span multilang>{{btntext}}</span>
            </button>
        </div>
        <ng-container *ngIf="showMore" [ngTemplateOutlet]="moreFilter"></ng-container>
    </div>
</ng-template>

<ng-template #homemodeMobile>
    <div class="tmp-inputs-wrapper-mobile">
        <div class="tmp-extrafilter-wraper-mobile w100">
            <app-city [mode]="'home'" class="w100"></app-city>
            <clever-date [start]="start" [end]="end" (selectValue)="selectValue($event)" [mode]="'home'"
                class="w100"></clever-date>
            <clever-selectionlist class="w100" [icon]="'people_alt'"
                [currentItem]="filter?.adults + (filter?.adults === '1' ? ' Person' : ' Personen')"
                (triggerChange)="selectAdultes($event)" [title]="'Raum für'" [bottomleftradius]="true"
                [bottomrightradius]="true" [list]="reisende" [mode]="'home'">
            </clever-selectionlist>
            <ng-container *ngIf="showMore" [ngTemplateOutlet]="moreFilterMobile"></ng-container>
            <button matTooltip="Mehr Filter" class="tmp-mehrfilter-mobile" (click)="openclosemore()" matRipple>
                <mat-icon>more_horiz</mat-icon>
            </button>
            <button class="tmpsearch tmpsearch-mobile tmpbtn w100 tmp-left tmp-right" (click)="gotoZiel()" matRipple>
                <mat-icon fontIcon="search"></mat-icon>
                <span multilang>{{btntext}}</span>
            </button>
        </div>
    </div>
</ng-template>

<ng-template #nohomefilter>
    <ng-container [ngSwitch]="media">
        <ng-container *ngSwitchCase="'xs'" [ngTemplateOutlet]="nohomemodeMobile"></ng-container>
        <ng-container *ngSwitchCase="'sm'" [ngTemplateOutlet]="nohomemodeMobile"></ng-container>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="nohomefilterdesk"></ng-container>
    </ng-container>
</ng-template>


<ng-template #nohomemodeMobile>
    <ng-container *ngIf="smallVersion else mbfilter">
        <div class="tmp-inputs-wrapper-nohome-mobile">
            <div class="smallfilter-mobile-wrapper mat-elevation-z1" (click)="showMBMenu()">
                <div class="m05">
                    <app-city [mode]="'nohomesmall'" class="w100"></app-city>
                    <div class="smallfilter-body">
                        <span class="smallitem">
                            <clever-date [start]="start" [end]="end" (selectValue)="selectValue($event)"
                                [mode]="'nohomesmall'"></clever-date> |
                        </span>
                        <span multilang class="smallitem">
                            {{filter?.adults}} P
                        </span>
                    </div>
                </div>
                <button class="smallfilter-btn" (click)="showMBMenu()" matRipple>
                    <mat-icon fontIcon="search"></mat-icon>
                </button>
            </div>
        </div>
    </ng-container>
</ng-template>

<ng-template #mbfilter>
    <div class="smallfilterbig-mobile-wrapper">
        <app-city [mode]="'nohome'" class="w100"></app-city>
        <clever-date [start]="start" [end]="end" (selectValue)="selectValue($event)" [mode]="'nohome'"
            class="w100"></clever-date>
        <clever-selectionlist class="w100" [icon]="'people_alt'"
            [currentItem]="filter?.adults + (filter?.adults === '1' ? ' Person' : ' Personen')"
            (triggerChange)="selectAdultes($event)" [title]="'Raum für'" [bottomleftradius]="true"
            [bottomrightradius]="true" [list]="reisende" [mode]="'nohome'">
        </clever-selectionlist>
        <button class="tmpsearch tmpsearch-mobile tmpbtn w100 tmp-left tmp-right" (click)="gotoZiel()" matRipple>
            <mat-icon fontIcon="search"></mat-icon>
            <span multilang>{{btntext}}</span>
        </button>
    </div>
</ng-template>

<ng-template #nohomefilterdesk>
    <div class="tmp-inputs-wrapper-nohome">
        <app-city [mode]="'nohome'" class="w100"></app-city>
        <clever-date [start]="start" [end]="end" (selectValue)="selectValue($event)" [mode]="'nohome'"
            class="w100"></clever-date>
        <clever-selectionlist class="w100" [icon]="'people_alt'"
            [currentItem]="filter?.adults + (filter?.adults === '1' ? ' Person' : ' Personen')"
            (triggerChange)="selectAdultes($event)" [title]="'Raum für'" [bottomleftradius]="true"
            [bottomrightradius]="true" [list]="reisende" [mode]="'nohome'">
        </clever-selectionlist>
        <button class="tmpsearch tmpsearch-mobile tmpbtn w100 tmp-left tmp-right" (click)="gotoZiel()" matRipple>
            <mat-icon fontIcon="search"></mat-icon>
            <span multilang>{{btntext}}</span>
        </button>
    </div>
</ng-template>

<ng-template #moreFilterMobile>
    <app-carrentextrafilters [mode]="'home'" class="w100" (closeModal)="openclosemore()">
    </app-carrentextrafilters>
</ng-template>

<ng-template #moreFilter>
    <app-carrentextrafilters [mode]="'home'" class="w100" (closeModal)="openclosemore()">
    </app-carrentextrafilters>
</ng-template>